import React, { useEffect, useState } from "react";

import { Breadcrumb, Button, PageHeader, Table, Tag, Spin } from "antd";

import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import TabMenu from "./TabMenu";
import { receiptService } from "_services";

function History({ match, history }) {
  const { id } = match.params;
  const { path } = match;

  const [historyItems, setHistoryItems] = useState([]);
  const [order, setOrder] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    getStockReceipt(id);
    getStockReceiptHistory(id);
  }, []);

  const getStockReceipt = (receiptId) => {
    setLoading(true);
    receiptService
      .getViewById(receiptId)
      .then((x) => {
        setOrder(x.content);
        setLoading(false);
      })
      .catch((errorInfo) => {
        setLoading(false);
        setError(errorInfo);
      });
  };

  const getStockReceiptHistory = (receiptId) => {
    setLoading(true);
    receiptService
      .getHistory(receiptId)
      .then((x) => {
        setHistoryItems(x.content);
        setLoading(false);
      })
      .catch((errorInfo) => {
        setLoading(false);
        setError(errorInfo);
      });
  };

  const onCancel = () => {
    history.push(`/packing-lists/${id}/summary`);
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Button key="btn-cancel" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  const getLineColumns = () => {
    let columns = [];
    columns.push({
      title: "Event",
      dataIndex: "event",
      key: "event",
    });
    columns.push({
      title: "Event Date",
      dataIndex: "eventDate",
      key: "eventDate",
      render: (text, record) => moment(text).format("YYYY-MM-DD HH:mm"),
    });
    columns.push({
      title: "Note",
      dataIndex: "notes",
      key: "notes",
    });
    columns.push({
      title: "Employee",
      dataIndex: "employeeName",
      key: "employeeName",
    });

    return columns;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/stock-receipts">Stock Receipts Search</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`.replace(":id", id)}>
              {order.receiptNumber} ::{" "}
              <Tag
                color={`${
                  order.orderStage === "OPEN"
                    ? "#2db7f5"
                    : order.orderStage === "IN_PROGRESS"
                    ? "#108ee9"
                    : "#87d068"
                }`}
              >
                {order.orderStage}
              </Tag>
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`${path}`}> History </Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      //Add buttons in the page header
      extra={getActionButtons()}
    >
      <Page inner>
        <Spin tip="Loading..." spinning={loading}>
          <TabMenu menu="history" id={id} status={order.orderStage} />

          {historyItems && (
            <Table
              bordered
              pagination={false}
              columns={getLineColumns()}
              dataSource={historyItems}
              size="small"
            />
          )}
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default History;
